import {
  Building2,
  Layers,
  PaintBucket,
  Home as HomeIcon,
  Wrench,
  ArrowUpRight,
  Sun,
} from "lucide-react";

const SERVICES = [
  {
    n: "01",
    title: "Rifacimento Facciate",
    desc: "Rasature, tinteggiature e risanamento di facciate condominiali. Ascensore da ponteggi proprietario fino a 30 metri di altezza.",
    icon: Building2,
    tags: ["Condomini", "Tinteggiature", "Rasature"],
  },
  {
    n: "02",
    title: "Cappotto Termico",
    desc: "Rivestimenti a cappotto certificati. Efficientamento energetico, accesso a detrazioni fiscali e supporto pratiche tecniche.",
    icon: Layers,
    tags: ["Isolamento", "Bonus", "ETICS"],
  },
  {
    n: "03",
    title: "Finiture d'Interni",
    desc: "Cartongesso, decorativi a calce e pitture di pregio. Soluzioni d'autore per spazi residenziali e commerciali.",
    icon: PaintBucket,
    tags: ["Cartongesso", "Calce", "Decorativi"],
  },
  {
    n: "04",
    title: "Ristrutturazioni Chiavi in Mano",
    desc: "Unico interlocutore dall'impresa al progetto. Demolizioni, impianti, finiture e arredo: consegniamo l'opera completa.",
    icon: HomeIcon,
    tags: ["Residenziale", "Commerciale"],
  },
  {
    n: "05",
    title: "Carpenteria & Design",
    desc: "Fabbro interno e officina dedicata: recinzioni, ringhiere, parapetti e cancelli moderni. Arredo industriale ferro+legno su misura: tavoli, pareti attrezzate, complementi.",
    icon: Wrench,
    tags: ["Ringhiere", "Recinzioni", "Arredo Industriale"],
    href: "/carpenteria",
    ctaLabel: "Sfoglia il portfolio",
  },
  {
    n: "06",
    title: "Impianti Fotovoltaici",
    desc: "Progettazione affidata a partner specializzato, posa e installazione direttamente con la nostra squadra. Soluzioni residenziali e condominiali con accesso a incentivi.",
    icon: Sun,
    tags: ["Energia", "Incentivi", "Posa Interna"],
  },
];

export default function Services() {
  return (
    <section
      id="servizi"
      data-testid="services-section"
      className="relative bg-[#050B14] py-28 md:py-40 grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Section header */}
        <div className="grid md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#FF5A1F]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#FF5A1F] font-bold">
                Servizi
              </span>
            </div>
            <div className="text-sm tracking-[0.25em] uppercase text-slate-500 font-mono">
              Cosa Facciamo / 006
            </div>
          </div>
          <div className="md:col-span-8">
            <h2 className="headline text-white text-4xl md:text-6xl">
              Sei aree operative.{" "}
              <span className="font-display italic font-medium text-slate-400">
                Una sola squadra.
              </span>
            </h2>
            <p className="mt-6 text-slate-400 max-w-2xl text-base md:text-lg">
              Gestiamo internamente ogni fase del cantiere: dalla struttura
              metallica al colore finale della facciata. Nessun subappalto
              critico, controllo totale sui tempi e sulla qualità.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1E293B]">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.n}
                data-testid={`service-card-${s.n}`}
                className="service-card p-8 md:p-10 bg-[#050B14] hover:bg-[#0A1120]"
              >
                <span className="accent-bar" />
                <div className="flex items-start justify-between mb-10">
                  <span className="font-mono text-xs tracking-[0.25em] text-slate-500">
                    / {s.n}
                  </span>
                  <Icon className="text-[#FF5A1F]" size={28} strokeWidth={1.5} />
                </div>

                <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight leading-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-slate-400 leading-relaxed text-sm md:text-base">
                  {s.desc}
                </p>

                <div className="mt-8 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span
                      key={t}
                      className="text-[11px] tracking-wider uppercase border border-slate-700 text-slate-400 px-2.5 py-1"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                <a
                  href={s.href || "#preventivo"}
                  className="mt-10 inline-flex items-center gap-2 text-sm text-white font-semibold link-underline"
                >
                  {s.ctaLabel || "Richiedi sopralluogo"} <ArrowUpRight size={16} />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
